import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const updateBookingBoardingInformations = async (bookingId: string, boardingInformations: string) => {
  return fetch(`/api/bookings/${bookingId}/boarding-informations`, "PATCH", { boardingInformations });
};

export const useBookingBoardingInformationsMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { boardingInformations: string; toastId: any }) =>
      updateBookingBoardingInformations(bookingId, data.boardingInformations),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Boarding informations updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking boarding informations!",
        variant: "destructive",
      });
    },
  });
};
